import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

export default function TermsPage() {
  const { t } = useTranslation()
  return (
    <main className="max-w-2xl mx-auto px-4 py-10 pb-32">
      <Link to="/" className="inline-flex items-center min-h-[48px] px-2 text-primary-text hover:underline mb-6">
        ← {t('terms.back')}
      </Link>
      <h1 className="text-2xl font-bold text-fg mb-6">{t('terms.title')}</h1>

      <section className="space-y-4 text-muted text-base leading-relaxed">
        <h2 className="text-lg font-semibold text-fg">{t('terms.pricesTitle')}</h2>
        <p>{t('terms.pricesBody')}</p>

        <h2 className="text-lg font-semibold text-fg">{t('terms.sourceTitle')}</h2>
        <p>{t('terms.sourceBody')}</p>

        <h2 className="text-lg font-semibold text-fg">{t('terms.availabilityTitle')}</h2>
        <p>{t('terms.availabilityBody')}</p>

        <h2 className="text-lg font-semibold text-fg">{t('terms.ipTitle')}</h2>
        <p>{t('terms.ipBody')}</p>

        <h2 className="text-lg font-semibold text-fg">{t('terms.impressumTitle')}</h2>
        <p>
          <Trans i18nKey="terms.impressumIntro" components={{ b: <strong /> }} />
        </p>
        <p>
          Infinapps j.d.o.o.<br />
          Radnička cesta 41<br />
          10000 Zagreb<br />
          Hrvatska
        </p>
        <p>
          OIB: 81491220481<br />
          E-pošta: info@infinapps.com<br />
          Web: <a href="https://infinapps.com" target="_blank" rel="noopener noreferrer" className="text-primary-text underline">infinapps.com</a>
        </p>
        <p>{t('terms.impressumNote')}</p>
      </section>
    </main>
  )
}
